import _Chart, { Series } from "devextreme-react/chart";
// Vite 8 CJS interop: with "type": "module", default import may resolve to module.exports (namespace object)
const Chart = ((_Chart as unknown as Record<string, unknown>)["default"] ?? _Chart) as typeof _Chart;
import { useCallback } from "react";
import { getBasicLegend } from "./utils/getBasicLegend.ts";
import { getBasicSerieLabel } from "./utils/getBasicSerieLabel.ts";
import { getBarWidthInPixels } from "./style/serie/getBarWidthInPixels.ts";
import { getShowPoints } from "./style/serie/getShowPoints.ts";
import { getMeasureCaption } from "../common/values/helper.tsx";
import { ChartCore } from "./ChartCore.tsx";
import type { ChartProps } from "./ChartProps.ts";
import { getDxSerieType } from "./helper.ts";
import { getValueAxisType } from "./style/serie/getValueAxisType.ts";

export default function Bar(props: ChartProps) {
  const updateRef = useCallback(
    (ref: InstanceType<typeof _Chart>) => {
      props.exportFunc(ref?.instance.exportTo.bind(ref.instance));
    },
    [props]
  );

  const renderSeries = () => {
    const argument = props.args[0];
    if (argument === undefined) return <></>;
    return props.values.map((value) => {
      const serie = props.settings.series?.find((s) => s.name === value.config.guid);
      return (
        <Series
          key={value.config.guid}
          argumentField={argument.meta.name}
          valueField={value.config.guid}
          name={value.config.guid}
          axis={getValueAxisType(serie)}
          type={getDxSerieType(props.settings, serie)}
          label={getBasicSerieLabel(value.config.guid, props.settings, props.data)}
          barPadding={0}
          barWidth={getBarWidthInPixels(serie)}
          point={{ visible: getShowPoints(serie) }}
        ></Series>
      );
    });
  };

  return (
    <ChartCore {...props}>
      <Chart
        ref={updateRef}
        dataSource={props.dataSource}
        legend={{
          ...getBasicLegend(props.settings),
          customizeText: ({ seriesName }) => getMeasureCaption(props.values.find((v) => v.config.guid === seriesName)),
        }}
      >
        {renderSeries()}
      </Chart>
    </ChartCore>
  );
}
